// Whether a click landed outside the peek and should dismiss it.
export function clickIsOutsideMenu(target: Element, menu: Element | null): boolean {
  if (menu?.contains(target)) return false

  // Clicks the modal drawer owns are never aimed at the page behind it: it
  // stacks above the menu and covers the viewport while open. Without this
  // the help dropdown is unreachable — the scrim swallows the click aimed at
  // the "?" button and collapses the menu instead.
  if (isModalDrawerClick(target)) return false

  // The hamburger handles itself.
  if (target.closest('[data-action*="side-menu#toggle"]')) return false

  return true
}

// The scrim and panel of the layout's right-hand drawer, plus the toggle
// checkbox itself: the scrim is a <label for="drawerToggle">, so its click is
// forwarded to the toggle and arrives here a second time, by which point the
// drawer has already closed. Scoped to the drawer that owns #drawerToggle so
// that unrelated in-page drawers still count as outside clicks.
function isModalDrawerClick(target: Element): boolean {
  const toggle = document.getElementById('drawerToggle')
  if (!toggle) return false
  if (target === toggle) return true

  const layer = toggle.parentElement?.querySelector(':scope > .drawer-side')
  return layer ? layer.contains(target) : false
}
